import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import AfternoonTeaBookings from './AfternoonTeaBookings';
import AfternoonTeaLogin from './AfternoonTeaLogin';

const PageWrapper = styled.div`
  padding-top: 20px;
  min-height: 100vh;
  
  @media (max-width: 768px) {
    padding-top: 15px;
  }
`;

/**
 * Wrapper component for Afternoon Tea Bookings with Security Center authentication
 * Uses the same login system as Security Center (API-based authentication)
 * Allows direct access via URL: /afternoon-tea-bookings
 */
const AfternoonTeaBookingsPage = () => {
  const [isAuthed, setIsAuthed] = useState(() => {
    // Check if user is authenticated via token (same as Security Center)
    return !!localStorage.getItem('token');
  });

  useEffect(() => {
    // Check authentication status when component mounts
    const token = localStorage.getItem('token');
    setIsAuthed(!!token);
  }, []);

  if (!isAuthed) {
    return <AfternoonTeaLogin onSuccess={() => setIsAuthed(true)} />;
  }

  return (
    <PageWrapper>
      <AfternoonTeaBookings />
    </PageWrapper>
  );
};

export default AfternoonTeaBookingsPage;
